import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { useCmsContent } from '../../hooks/useCmsContent';

const TestimonialSection = () => {
  const { getContentValue, loading } = useCmsContent({ section: 'counters' });
  
  const testimonials = [
    {
      text: "In questo periodo così difficile per l'affitto di un immobile ci siamo rivolti a Federico persona molto gentile che in poco tempo è riuscito a trovare la soluzione giusta per noi. Grazie",
      author: "Mariarca Di Martino",
      location: ""
    },
    {
      text: "Affidabilità, competenza, serietà, mi sono sentita accolta e seguita in tutto l'iter. Grazie di cuore!",
      author: "Lucilla Bernardi",
      location: ""
    },
    {
      text: "Appena completato una transazione. Estremamente raccomandabile. Federico si è prodigato per fornire tutte le necessarie informazioni in tempo reale, disponibile, gentile e professionale … un piacere averlo conosciuto…. 5 stelle se le merita tutte !!!",
      author: "Simone Berni",
      location: ""
    }
  ];

  return (
    <section id="testimonials" className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="text-secondary uppercase tracking-wider font-semibold">Le Esperienze</span>
          <h2 className="text-4xl font-monomakh text-primary mt-2 mb-4">Cosa Dicono i Nostri Clienti</h2>
          <p className="text-gray-600 text-lg max-w-3xl mx-auto">
            Non devi credere solo alle nostre parole. 

            Ecco cosa dicono i clienti che hanno scelto di affidarsi a noi.
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              variants={{
                hidden: { opacity: 0, y: 20 },
                visible: { opacity: 1, y: 0 }
              }}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
              className="bg-white rounded-lg shadow-lg p-8 relative"
            >
              <div className="absolute top-0 right-0 transform translate-x-2 -translate-y-2 bg-secondary text-white w-10 h-10 rounded-full flex items-center justify-center">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="h-6 w-6">
                  <path d="M9.24 9.17C8.43 9.4 7.74 10.03 7.51 10.84C7.08 12.35 8.55 13.82 10.06 13.39C10.87 13.16 11.5 12.47 11.73 11.66C12.16 10.15 10.69 8.68 9.18 9.11L9.24 9.17ZM16.67 9.17C15.86 9.4 15.17 10.03 14.94 10.84C14.51 12.35 15.98 13.82 17.49 13.39C18.3 13.16 18.93 12.47 19.16 11.66C19.59 10.15 18.12 8.68 16.61 9.11L16.67 9.17Z" fill="currentColor"/>
                </svg>
              </div>
              
              <div className="flex space-x-1 mb-4 text-yellow-400">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-5 w-5 fill-current" />
                ))}
              </div>
              
              <p className="text-gray-600 mb-6 italic">{testimonial.text}</p>
              
              <div>
                <h4 className="font-semibold text-primary">{testimonial.author}</h4>
                {testimonial.location && <p className="text-gray-500 text-sm">{testimonial.location}</p>}
              </div>
            </motion.div>
          ))}
        </div>
        
        {/* Trust badges */}
        <motion.div
          variants={{
            hidden: { opacity: 0 },
            visible: { opacity: 1 }
          }}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mt-16 p-6 bg-gray-50 rounded-xl"
        >
          <div className="text-center mb-8">
            <h3 className="text-2xl font-semibold text-primary mb-2">Riconosciuti per l'Eccellenza</h3>
            <p className="text-gray-600">Siamo orgogliosi di essere riconosciuti per la qualità del nostro servizio</p>
          </div>
          <div className="flex flex-wrap justify-center items-center gap-12">
            <div className="text-center px-6">
              <div className="text-4xl font-bold text-primary mb-2">{getContentValue('percentuale_clienti_soddisfatti') || "97%"}</div>
              <p className="text-gray-600">Clienti Soddisfatti</p>
            </div>
            <div className="h-12 w-px bg-gray-300 hidden md:block"></div>
            <div className="text-center px-6">
              <div className="text-4xl font-bold text-primary mb-2">{getContentValue('valutazione_media') || "5/5"}</div>
              <p className="text-gray-600">Valutazione Media</p>
            </div>
            <div className="h-12 w-px bg-gray-300 hidden md:block"></div>
            <div className="text-center px-6">
              <div className="text-4xl font-bold text-primary mb-2">{getContentValue('giorni_vendita_media') || "45"}</div>
              <p className="text-gray-600">Giorni Medi di Vendita</p>
            </div>
            <div className="h-12 w-px bg-gray-300 hidden md:block"></div>
            <div className="text-center px-6">
              <div className="text-4xl font-bold text-primary mb-2">{getContentValue('immobili_venduti') || "300"}+</div>
              <p className="text-gray-600">Proprietà Vendute</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default TestimonialSection;